import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CompanyService } from '../company-service';
import type { GetCompanyTreeResponse, GetCompanyTreeRequest } from '../../apis/company-tree-api';
import type { GetCompanyNameResponse, GetCompanyNameRequest } from '../../apis/company-name-api';
import { GetCompanyTreeApi } from '../../apis/company-tree-api';
import { GetCompanyNameApi } from '../../apis/company-name-api';

@injectable()
export class CompanyServiceImpl implements CompanyService {
    constructor(
        @inject(GetCompanyTreeApi)
        private _companyTreeApi: GetCompanyTreeApi,
        @inject(GetCompanyNameApi)
        private _companyNameApi: GetCompanyNameApi,
    ) {}

    public async getCompanyTree(query: string, exactMatch = false): Promise<GetCompanyTreeResponse> {
        const request: GetCompanyTreeRequest = {
            q: query,
            exact_match: exactMatch,
            active: false,
            rows: '50',
        };

        return await this._companyTreeApi.getCompanyTree(request);
    }

    public async searchCompaniesByName(
        query: string,
        fuzzyMatch = false,
        limit = 10,
    ): Promise<GetCompanyNameResponse> {
        const request: GetCompanyNameRequest = {
            q: query,
            n: limit,
            search_mode: fuzzyMatch ? 'publication' : 'family',
        };

        return await this._companyNameApi.getCompanyByName(request);
    }
}
